import {
  SIGNIN,
  SIGNINSUCCESS,
  SIGNINFAILURE,
  SIGNOUT,
  SIGNUP,
  SIGNUPSUCCESS,
  SIGNUPFAILURE,
  AUTH_CHALLENGE,
  CLEAR_AUTH_CHALLENGE
} from '../types';

const initialState = {
  isAuthenticated: false,
  user: null,
  loading: false,
  error: null,
  token: null,
  authChallenge: '',
  challengeUser: null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGNIN:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case SIGNINSUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        user: action.user,
        token: action.token,
        loading: false,
        error: null
      };
    
    case SIGNINFAILURE:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token: null,
        loading: false,
        error: action.error || 'Sign in failed'
      };
    
    case AUTH_CHALLENGE:
      return {
        ...state,
        authChallenge: action.challengeName,
        challengeUser: action.user,
        loading: false,
        error: null
      };
    
    case CLEAR_AUTH_CHALLENGE:
      return {
        ...state,
        authChallenge: '',
        challengeUser: null
      };
    
    case SIGNUP:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case SIGNUPSUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
    
    case SIGNUPFAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || 'Sign up failed'
      };
    
    case SIGNOUT:
      return {
        ...initialState
      };
    
    default:
      return state;
  }
};

export default authReducer; 